module.exports = __webpack_public_path__ + "img/restrict.31ebf8e8.svg";